<template>
    <div>
    <Popup v-model="popupShow" closeable close-icon-position="top-right"  @close="close" style="width: 90%" >
            <NavBar title="添加"  />
            <Field
                    clearable
                    v-model="productName"
                    label="产品名称"
                    placeholder="请选择产品名称"
                    readonly
                    required
                    right-icon="arrow-down"
                    @click="selectProduct()"
                    :rules="[{ required: true, message: '产品类型必填' }]"
            />
            <Field
                    clearable
                    required
                    v-model="count"
                    label="数量"
                    placeholder="请输入数量"
                    :rules="[{ required: true, message: '数量不为空' }]"
            />
            <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">提交</Button>
        </Popup>
        <SelectProductPopup :products="products"  :show="productPanel"    @ok="onSelectProduct" @cancel="productPanel=false"/>
    </div>
</template>

<script>
    import {Popup,Form,Field,Button,NavBar} from "vant"
    import SelectProductPopup from "@/components/SelectPopup/SelectProductPopup";

    export default {
        components:{Popup,Form,Field,Button,NavBar,SelectProductPopup},
        props:{
            type: {type: String, default: "default"},
            show: { type: Boolean, default: false }
        },
        data(){
            return{
                taskId:this.$route.params.id,
                count:null,
                productName:null,
                productId:null,
                popupShow:false,
                productPanel: false,
                products:[]
            }
        },
        computed: {
        },
        created(){},
        mounted(){
            this.getProducts()
        },
        methods:{
            selectProduct() {
                this.productPanel = true;
            },
            getProducts() {
               this.$http.tokiot.sys.product.listAuthorized({})
                    .then(res => {
                        if(res){
                            this.products = res;
                        }
                    })
            },
            onCancel() {
                this.productPanel = false;
            },
            onSelectProduct(product){
                this.productName = product.productName;
                this.productId = product.id;
                this.productPanel=false;
            },
            close() {
                this.$emit('panel', this.type,)
            },
            submit(){
                this.$toast.loading("正在提交中...");
                this.$http.tokiot.prospect.taskDevice.submit({
                    taskId: this.taskId,
                    productId:this.productId,
                    count: this.count
                }).then(res=>{
                    if(res){
                        this.$toast.success("添加成功");
                        this.popupShow = !this.popupShow
                       this.$emit("onRefresh")
                    }else{
                        this.$toast.fail(res.message)
                    }
                })
            }
        },
        watch:{
            show(show){
                this.popupShow=show
            }
        }
    }
</script>

<style scoped>

</style>